import React from 'react';

export default function ActionItemAssignMember({member, ndx}) 
{
    var option_text = `${ndx}-${member.UserFullName}`;
    return (
        <>
            <option value={option_text}/>
        </>
    );
}